import { FieldConfig } from '../../restaurant/models';
import { MergedCustomFields } from '../../party';
import { Customer } from '../models';

export function extractPartyFieldsFromCustomer(
  config: FieldConfig[],
  customer: Customer,
): MergedCustomFields {
  const customFields: Record<string, unknown> = {};
  for (const fieldDefinition of config) {
    if (fieldDefinition.enabled && fieldDefinition.customer) {
      customFields[fieldDefinition.id] = customer.customFields[fieldDefinition.id];
    }
  }

  return {
    name: customer.name,
    customFields,
  };
}
